import { updatedCredits } from "../services";

const stringAvatar = (name = "", theme = {}) => {
  const [firstname, lastname] = name.split(" ");
  let iconName = "";
  if (firstname) {
    iconName += `${firstname[0].toUpperCase()}`;
  }
  if (lastname) {
    iconName += `${lastname[0].toUpperCase()}`;
  }
  return {
    children: iconName.length > 0 ? iconName : "NA",
  };
};
const SentenceCase = (s) => {
  return s
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase())
    .join(" ");
};
const getFormattedDate = (dateString) => {
  const inputDate = new Date(dateString);
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const formattedDate = inputDate.toLocaleDateString("en-US", options);
  return formattedDate;
};

const getUpdatedCredits = async () => {
  const { id } = JSON.parse(sessionStorage.getItem("userDetails"));
  const res = await updatedCredits(id);
  return res;
};

const formatDate = (date) => {
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatDateToDMY = (dateString, includeTime = false) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 0-indexed
  const year = date.getFullYear();

  const datePart = `${day}-${month}-${year}`;

  if (includeTime) {
    const time = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
    return `${datePart}, ${time}`;
  }

  return datePart;
}
export {
  SentenceCase,
  getFormattedDate,
  stringAvatar,
  getUpdatedCredits,
  formatDate,
  formatDateToDMY
};
